import { AvField, AvForm } from "availity-reactstrap-validation";
import React, { useState, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../../helpers/units";
import moment from "moment";
import { useEffect } from "react";
import UpdateQuantityWithRemark from "./UpdateQuantityWithRemark";

const CloseOrderModal = ({
  isOpen,
  toggle,
  t,
  order,
  adminRemarks,
  setAdminRemarks,
  confirmClose,
  setConfirmClose,
  onCancel,
  onConfirm,
}) => {
  // console.log(order,"order");

  const rowStyleForReceive = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8" };
    if (row.is_new_item_added) {
      style.backgroundColor = "#90EE90";
    } else {
      style.backgroundColor = "";
    }
    return style;
  };

  const [selectedItem, setSelectedItem] = useState(null);
  const [deliveredModal, setDeliveredModal] = useState(false);
  const [itemsForCloseOrder, setItemsForCloseOrder] = useState(
    order?.delivery_details?.map((item) => ({
      ...item,
      new_delivered_quantity: item.delivered_quantity,
      csm_remarks: "",
      original_delivered_quantity: item.delivered_quantity,
    })) || []
  );
  //   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    setItemsForCloseOrder(
      order?.delivery_details?.map((item) => {
        const receivedInLowestUnit = convertToLowestUnit(
          item.unit_levels,
          item.received_quantity
        );
        const deliveredInLowestUnit = convertToLowestUnit(
          item.unit_levels,
          item.delivered_quantity
        );
        const remaining = deliveredInLowestUnit - receivedInLowestUnit;

        return {
          ...item,
          new_delivered_quantity: item.delivered_quantity,
          csm_remarks: "",
          original_delivered_quantity: item.delivered_quantity,
          remaining_quantity:
            remaining > 0
              ? GetUpdatedDelivered(
                  [
                    {
                      unit: item.unit_levels[item.unit_levels.length - 1].unit,
                      value: remaining,
                    },
                  ],
                  item.unit_levels
                )
              : [],
          current_remaining_quantity:
            remaining > 0
              ? GetUpdatedDelivered(
                  [
                    {
                      unit: item.unit_levels[item.unit_levels.length - 1].unit,
                      value: remaining,
                    },
                  ],
                  item.unit_levels
                )
              : [],
        };
      })
    );
  }, [order]);

  function deliveredQuantityFormatter(cell, row) {
    const { unit_levels, received_quantity, original_delivered_quantity } = row;

    let totalReceived = convertToLowestUnit(unit_levels, received_quantity);
    let originalDelivered = convertToLowestUnit(
      unit_levels,
      original_delivered_quantity
    );
    let untracked = originalDelivered - totalReceived;

    const isUntracked = untracked > 0;
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(
              row.new_delivered_quantity && row.new_delivered_quantity
            )}
          </span>
          {/* <Button
            hidden={!isUntracked}
                className="btn btn-success btn-sm"
                onClick={() => {
                  let updatedItem = {
                    ...row,
                    quantity:row.new_delivered_quantity?.map((item, idx) => ({
                      ...item,
                      index: idx,
                      isChecked: true,
                    })),
                  }
                  setSelectedItem(updatedItem)
                  setDeliveredModal(!deliveredModal);
                }}
              >
                <i class="mdi mdi-edit"></i>
                {t("Edit")}
              </Button> */}
        </div>
      </>
    );
  }

  const getCellStyle = (row, cell) => {
    const {
      unit_levels,
      received_quantity,
      new_delivered_quantity,
      original_delivered_quantity,
    } = row;

    let totalReceived = convertToLowestUnit(unit_levels, received_quantity);
    let newDelivered = convertToLowestUnit(unit_levels, new_delivered_quantity);
    let originalDelivered = convertToLowestUnit(
      unit_levels,
      original_delivered_quantity
    );
    let untracked = newDelivered - totalReceived;
    let untrackedForRemark = originalDelivered - totalReceived;
    const isQuantityChanged = untracked > 0;
    const isRemarkdEditable = untrackedForRemark > 0;
    const isRemarksEmpty = !row.csm_remarks || row.csm_remarks.trim() === "";

    if (cell == "qty") {
      return {
        cursor: "pointer",
        background: isQuantityChanged ? "#ffb8b8" : "",
        // background: isQuantityChanged && isRemarksEmpty ? "#ffb8b8" : "#ffffaa",
      };
    } else if (cell == "remark") {
      return {
        cursor: "pointer",
        background: isRemarkdEditable && isRemarksEmpty ? "#ffffaa" : "",
      };
    }
  };

  const columns_delivered_items = [
    {
      text: t("Item"),
      dataField: "item_category",
      formatter: (cell, row) => (
        <div style={{ lineHeight: "2" }}>
          <div>{row.name}</div>
          {/* <div style={{ color: '#7f8c8d', fontSize: '11px' }}>
          ({row.category})
        </div> */}
        </div>
      ),
      editable: false,
      sort: true,
      headerStyle: { width: "20%" },
    },
    {
      text: t("Batch"),
      dataField: "batch",
      sort: true,
      formatter: (cell, row) => (
        <div style={{ lineHeight: "2" }}>
          <div>{row.batch}</div>
        </div>
      ),
      editable: false,
      headerStyle: { width: "12%" },
    },
    {
      text: t("Dispatch Time"),
      dataField: "dispatch_info",
      formatter: (cell, row) => (
        <div style={{ lineHeight: "1.4" }}>
          {/* <div>
          {row.delivered_from}
        </div> */}
          <div style={{ marginTop: "0px" }}>
            {moment(row.date_of_transaction).format("YYYY-MM-DD HH:mm")}
          </div>
        </div>
      ),
      editable: false,
      sort: true,
      headerStyle: { width: "12%" },
    },
    {
      dataField: "delivered_quantity",
      text: t("Dispatch Qty."),
      formatter: deliveredQuantityFormatter,
      attrs: (cell, row, rowIndex, colIndex) => {
        return { title: "Click to Edit" };
      },
      //    style: (cell, row) => getCellStyle(row,'qty'),
      editable: false,
      sort: true,
      headerStyle: { width: "16%" },
    },
    {
      dataField: "received_quantity",
      text: t("Rec. Qty."),
      formatter: (cell, row) => (
        <div style={{ lineHeight: "2" }}>
          <div>
            {row.is_received ? (
              formatUnitsForReport(row.received_quantity, row.unit_levels)
            ) : (
              <span style={{ color: "#bdc3c7", fontStyle: "italic" }}>
                Not Yet Received{" "}
              </span>
            )}
          </div>
        </div>
      ),
      sort: true,
      editable: false,
      headerStyle: { width: "13%" },
    },
    {
      text: t("Remaining Qty."),
      dataField: "current_remaining_quantity",
      formatter: (cell, row) => (
        <div style={{ lineHeight: "2" }}>
          {formatUnitsForReport(
            row.current_remaining_quantity,
            row.unit_levels
          )}
        </div>
      ),
      sort: true,
      editable: false,
      headerStyle: { width: "10%" },
    },
    {
      text: t("Action"),
      dataField: "action",
      formatter: (cell, row) => {
        let originalDeliverd = convertToLowestUnit(
          row.unit_levels,
          row.delivered_quantity
        );
        let received = convertToLowestUnit(
          row.unit_levels,
          row.received_quantity
        );
        const hasRemaining = originalDeliverd > received;
        return (
          <>
            {hasRemaining && (
              <Button
                outline
                color="info"
                size="sm"
                //   className="btn btn-outline-info btn-sm"
                onClick={() => {
                  setSelectedItem(row);
                  setDeliveredModal(true);
                }}
              >
                <i className="fas fa-cog"></i> {t("Manage")}
              </Button>
            )}
          </>
        );
      },
      editable: false,
      headerStyle: { width: "10%" },
    },
    {
      text: t("Branch Remarks"),
      dataField: "remarks",
      formatter: (cell, row) => (
        <div
          style={{
            fontSize: "11px",
            lineHeight: "2",
            color: "#5d6d7e",
          }}
        >
          {row.remarks ? (
            <div>
              <div>{row.remarks}</div>
            </div>
          ) : null
          //   <span style={{ color: '#bdc3c7', fontStyle: 'italic' }}>No remarks</span>
          }
        </div>
      ),
      editable: false,
      headerStyle: { width: "8%" },
    },
    {
      text: t("CSM Remarks"),
      dataField: "csm_remarks",
      formatter: (cell, row) => (
        <div
          style={{
            fontSize: "11px",
            lineHeight: "2",
            color: "#5d6d7e",
          }}
        >
          {row.csm_remarks ? (
            <div>
              <div>{row.csm_remarks}</div>
            </div>
          ) : null
          //   <span style={{ color: '#bdc3c7', fontStyle: 'italic' }}>No remarks</span>
          }
        </div>
      ),
      editable: (cell, row) => {
        const { unit_levels, received_quantity, original_delivered_quantity } =
          row;

        let totalReceived = convertToLowestUnit(unit_levels, received_quantity);
        let originalDelivered = convertToLowestUnit(
          unit_levels,
          original_delivered_quantity
        );
        let untracked = originalDelivered - totalReceived;

        return untracked > 0;
      },
      attrs: { title: "Click to Edit" },
      style: (cell, row) => getCellStyle(row, "remark"),
      headerStyle: { width: "8%" },
    },
  ];

  const isCloseable = ["Partially Received"].includes(order?.status);

  // console.log(itemsForCloseOrder,"items for close ourder");

  const handleSubmit = (rollbackQuantity, damagedQuantity, remarks) => {
    const updatedItems = itemsForCloseOrder.map((item) => {
      if (item._id === selectedItem._id) {
        const newRemainingQuantityInLowestUnit =
          (convertToLowestUnit(
            item.unit_levels,
            item.current_remaining_quantity
          ) || 0) -
          (rollbackQuantity + damagedQuantity);
        const finalNewDeliveredQuantityInLowestUnit =
          (convertToLowestUnit(
            item.unit_levels,
            item.original_delivered_quantity
          ) || 0) -
          (convertToLowestUnit(item.unit_levels, damagedQuantity) || 0) -
          (convertToLowestUnit(item.unit_levels, rollbackQuantity) || 0);
        const updatedDeliveredQuantity = GetUpdatedDelivered(
          [
            {
              unit: item.unit_levels[item.unit_levels.length - 1].unit,
              value: finalNewDeliveredQuantityInLowestUnit,
            },
          ],
          item.unit_levels
        );
        const updatedRemainingQuantity = GetUpdatedDelivered(
          [
            {
              unit: item.unit_levels[item.unit_levels.length - 1].unit,
              value: newRemainingQuantityInLowestUnit,
            },
          ],
          item.unit_levels
        );

        return {
          ...item,
          csm_remarks: remarks,
          new_delivered_quantity: updatedDeliveredQuantity,
          current_remaining_quantity: updatedRemainingQuantity,
          rollback_quantity: rollbackQuantity,
          damaged_quantity: damagedQuantity,
        };
      }
      return item;
    });

    setItemsForCloseOrder(updatedItems);
    setSelectedItem(null);
    setDeliveredModal(false);
    // onConfirm(updatedItems)
    return true;
  };

  return (
    <React.Fragment>
      <Modal size={isCloseable ? "xl" : "md"} isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          Order ID: {order && order.order_id}
        </ModalHeader>
        <ModalBody>
          <>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <AvForm
                      onValidSubmit={(e, v) => {
                        setConfirmClose(true);
                      }}
                    >
                      {/* dispatched items  */}
                      {order &&
                        order.delivery_details?.length > 0 &&
                        isCloseable && (
                          <Row>
                            <Col lg={12} md={12}>
                              <Label>Dispatched Items</Label>
                            </Col>

                            <Col lg={12}>
                              <BootstrapTable
                                bootstrap4
                                keyField="_id"
                                data={itemsForCloseOrder}
                                columns={columns_delivered_items}
                                noDataIndication="No data to display."
                                striped
                                hover
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                  afterSaveCell: (
                                    oldValue,
                                    newValue,
                                    row,
                                    column
                                  ) => {
                                    // If new value is empty (null, undefined, or just spaces)
                                    // if (newValue === null || newValue === undefined || newValue.toString().trim() === "") {
                                    //     const restoredItems = itemsForCloseOrder.map(item => {
                                    //     if (item._id === row._id) {
                                    //         return { ...item, [column.dataField]: oldValue };
                                    //     }
                                    //     return item;
                                    //     });
                                    //     setItemsForCloseOrder(restoredItems);
                                    //     return;
                                    // }

                                    const updatedItems = itemsForCloseOrder.map(
                                      (item) => {
                                        if (item._id === row._id) {
                                          return {
                                            ...item,
                                            [column.dataField]: newValue,
                                          };
                                        }
                                        return item;
                                      }
                                    );
                                    setItemsForCloseOrder(updatedItems);
                                  },
                                })}
                                condensed
                                rowStyle={rowStyleForReceive}
                              />
                              {/* <hr /> */}
                            </Col>
                          </Row>
                        )}
                      <Row>
                        <Col lg={isCloseable ? 6 : 12}>
                          <AvField
                            name="admin_remarks"
                            placeholder="Enter remarks"
                            type="textarea"
                            onChange={(e) => setAdminRemarks(e.target.value)}
                            value={adminRemarks}
                            label="Remarks"
                            validate={{
                              required: {
                                // value: isCloseable ? false : true,
                                value: true,
                                errorMessage: "Remarks cannot be empty.",
                              },
                            }}
                          />
                        </Col>

                        <Col lg={12}>
                          <hr />
                          <FormGroup className="mb-0 text-center">
                            <div>
                              <Button
                                type="submit"
                                color="primary"
                                className="mr-1"
                              >
                                {t("Submit")}
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        </ModalBody>
      </Modal>
      {/* ---Confirmation Close Remarks Modal Starts--- */}
      {confirmClose && (
        <SweetAlert
          title={t("Are you sure?")}
          warning
          showCancel
          cancelBtnText={t("No")}
          confirmBtnText={t("Yes")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            let itemsToClosed = itemsForCloseOrder
              .filter((item) => {
                const originalDelivered = convertToLowestUnit(
                  item.unit_levels,
                  item.original_delivered_quantity
                );
                const newDelivered = convertToLowestUnit(
                  item.unit_levels,
                  item.new_delivered_quantity
                );
                const isQuantityChanged = originalDelivered !== newDelivered;
                const isRemarksEntered =
                  item.csm_remarks && item.csm_remarks.trim() !== "";
                return isQuantityChanged || isRemarksEntered;
              })
              .map((item) => ({
                ...item,
                delivered_quantity: item.new_delivered_quantity,
              }));
            onConfirm(itemsToClosed);
          }}
          onCancel={onCancel}
        >
          {t("Once you close this order, it cannot be revoked.")}
        </SweetAlert>
      )}

      {/* ---Confirmation Close Remarks Modal Ends--- */}

      <UpdateQuantityWithRemark
        isOpen={deliveredModal}
        toggle={() => setDeliveredModal(false)}
        onSubmit={handleSubmit}
        item={selectedItem}
        checkLimitFor={"delivered"}
      />
    </React.Fragment>
  );
};

export default CloseOrderModal;
